























































































import { Component, Provide, Vue } from 'vue-property-decorator';
import { db } from '@/firebase';

@Component({
    components: {}
})
export default class SubscribeBox extends Vue {
    @Provide()
    email: string | null = null;

    @Provide()
    state: 'idle' | 'loading' | 'done' | 'invalid' = 'idle';

    getIsValidEmail() {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return this.email?.length ?? 0 > 2
            ? re.test(String(this.email).toLowerCase())
            : true;
    }

    async subscribe() {
        this.state = 'loading';

        if (!this.getIsValidEmail() || !this.email || this.email.length === 0) {
            this.state = 'invalid';
        } else {
            await db.collection('emails').add({
                email: this.email
            });
            this.state = 'done';
        }
    }
}
